import React from "react";

const SignIn = () => {
    return (
        <div>
            <h1>Sign In</h1>
            <form id = "signin-form">
               <input type="email" placeholder="Email" required/>
               <input type="password" placeholder="Password" required/>
               <input type="submit" value="Submit"/>
            </form>
        </div>
    )
}

export default SignIn;